import React from 'react';
import cn from 'classnames';
import { getYearsRange } from './utils';
import "./styles.css";
export var Years = function (_a) {
    var _b = _a.minYear, minYear = _b === void 0 ? 1930 : _b, _c = _a.maxYear, maxYear = _c === void 0 ? new Date().getFullYear() + 10 : _c, selectedYear = _a.selectedYear, onSelectYear = _a.onSelectYear, showStartPanel = _a.showStartPanel;
    var years = getYearsRange(minYear, maxYear);
    var onClick = function (year) {
        onSelectYear(year);
        showStartPanel();
    };
    return (React.createElement("div", { className: 'lk-ui_calendar-years' }, years.map(function (year) { return (React.createElement("span", { className: cn('year', {
            selected: year === selectedYear,
        }), onClick: function () { return onClick(year); }, key: "year-" + year }, year)); })));
};
